/**
 * Link-safety allowlist shared by the inline formatter and the markdown
 * adapter's `urlTransform`.
 *
 * Assistant text is model output, so a `javascript:` or `data:` href is one
 * prompt away. Anything not on this list renders as plain text rather than as
 * an anchor — dropping the link is always safer than rendering a live one.
 */
const ALLOWED = ['http:', 'https:', 'mailto:', 'doc:']

/** Internal reference into the document preview, handled in-app not via href. */
export function isDocRef(href) {
  return String(href ?? '').startsWith('doc:')
}

export function docSectionId(href) {
  return String(href ?? '').slice('doc:'.length)
}

/** @returns {string | null} the href to use, or null when it must not be linked. */
export function safeHref(href) {
  const value = String(href ?? '').trim()
  if (!value) return null
  // Relative and anchor links never carry a scheme and cannot escape the app.
  if (value.startsWith('/') || value.startsWith('#')) return value
  try {
    const { protocol } = new URL(value, 'https://placeholder.invalid')
    return ALLOWED.includes(protocol) ? value : null
  } catch {
    return null
  }
}
